define(function(require) {
    'use strict';

    var i18n = require('i18n');
    var mathUtil = require('util/math.util');
    var userValidationHelpers = require('modules/user/user.validation.helpers');

    userValidationHelpers.validateIban = function($inputs, conf, form, state, event, data) {
        this.message = i18n.t('playtech.mobile.registration.iban.error.doubleCheck');
        var value = $inputs.val().trim().replace(/\s+/g, ''); /* TotalCasino changes */

        if (!data.countrycode || !value || !/\d+/.test(value)) {
            return false;
        }

        var countryCodeNum = Array.from(data.countrycode)
            .map(function(char) {
                return char.charCodeAt(0) - 55;
            })
            .join('');

        var ibanMod = value.substring(2) + countryCodeNum + value.substring(0, 2);

        return mathUtil.modulo(ibanMod, 97) === 1;
    };

    return userValidationHelpers;
});
